import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=6a4b2b7f&scoped=true&"
import script from "./Value.vue?vue&type=script&lang=ts&"
export * from "./Value.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4b2b7f",
  null
  
)

export default component.exports